window.initLanguageSelect = () => {
    $(document).click(function(e) {
        const target = $(e.target);
        const langDropdowns = $('.lang-select');

        const isActive = langDropdowns.hasClass('header__lang_active');
        const isLangSelect = !!target.closest(langDropdowns).length;

        if (isLangSelect && !isActive) {
            langDropdowns.addClass('header__lang_active');
        } else {
            langDropdowns.removeClass('header__lang_active');
        }
    });
}
